
export interface LikeResponse {
  likeCount?: number;
  success?: boolean;
}
